import React, { useEffect } from 'react';
import type { FC } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';

import { wt } from '@admin/initializers/wt';

import { allowed } from './helpers';
import { ROUTES } from './routes';
import type { RouteState } from './types';

const GUARDED_ROUTE_STATES = new Set<RouteState>([
  'accounts',
  'claim',
  'claims',
  'collections',
  'doorToDoorRateAdjustments',
  'engineeringRoadmap',
  'inbox',
  'viewTicket',
  'newTicket',
  'ticketmanagement',
  'hiringJobListings',
  'hiringRoles',
  'hiringInterviewTimeSlots',
  'hiringCandidates',
  'hiringJobApplicationReview',
  'newHiringRole',
  'editHiringRole',
  'newHiringJobListing',
  'editHiringJobListing',
  'hiringPreScreenQuestions',
  'newHiringPreScreenQuestion',
  'editHiringPreScreenQuestion',
  'newPricingUpload',
  'pricingUploads',
  'selfStorageFacilities',
  'selfStorageRateAdjustmentUploader',
  'selfStorageUnitDetail',
  'selfStorageUnitsIndex',
  'phoneCalls',
  'customerTickets',
  'viewCustomerTicket',
  'smsInbox',
  'sopDocuments',
  'trainingUploadAttestations',
  'trainingUploadEdit',
  'trainingUploadNew',
  'trainingUploads',
  'timeClock',
  'voicemails',
  'yieldManagement',
  'featureFlags',
  'iterableExports',
  'landingLocationCityDetails',
  'landingLocationCityList',
  'landingLocationContent',
  'landingLocationNeighborhood',
  'landingLocationNeighborhoodList',
  'landingLocationPageDetails',
  'landingLocationPageList',
  'landingLocationRoute',
  'landingLocationRouteList',
  'landingLocationStateList',
  'manageItemCategories',
  'newLandingLocationCity',
  'editLandingLocationCity',
  'newLandingLocationContent',
  'editLandingLocationContent',
  'newLandingLocationNeighborhood',
  'editLandingLocationNeighborhood',
  'newLandingLocationPage',
  'editLandingLocationPage',
  'newLandingLocationRoute',
  'editLandingLocationRoute',
  'newLandingLocationState',
  'editLandingLocationState',
  'teams',
  'redirects',
  'newRedirect',
  'editRedirect',
  'affiliates',
  'newAffiliate',
  'editAffiliate',
  'showAffiliate',
  'coupons',
  'newCoupon',
  'showCoupon',
  'editCoupon',
  'referrals',
  'newReferral',
  'utmPhones',
  'qrCodeGenerator',
  'accessControlCatalog',
  'accessControlPermissions',
  'userSkills',
  'partnershipsPartners',
  'ptoRequests',
  'users',
  'viewUser',
  'newUser',
  'editUser',
  'warehouseTasks',
  'warehouseTaskNew',
  'warehouseTaskShow',
  'vehicles',
  'showVehicle',
  'newVehicle',
  'editVehicle',
  'nightTransportPlanner',
  'vehicleRouteMatcher',
  'dispatches',
  'dispatcher',
  'map',
  'viewDispatch',
  'editDispatch',
]);

export const Router: FC = () => {
  const history = useHistory();
  const routes = ROUTES.filter((route) => !GUARDED_ROUTE_STATES.has(route.state) || allowed(route.state));

  useEffect(() => {
    const unlisten = history.listen(() => {
      wt.track('pageview');
    });

    return () => unlisten();
  }, [history]);

  return (
    <Switch>
      {routes.map((route, index) => (
        <Route exact key={index} path={route.path} component={route.component} />
      ))}
    </Switch>
  );
};
